import { createFileRoute } from "@tanstack/react-router";
import { UkServicePage, ukHead } from "@/components/site/UkServicePage";

export const Route = createFileRoute("/uk/seo-for-solicitors")({
  head: () => ukHead("/uk/seo-for-solicitors"),
  component: () => <UkServicePage path="/uk/seo-for-solicitors" />,
});
